import { createFileRoute, redirect } from '@tanstack/react-router'

import { publicEntryPath } from '@/features/auth/route-access'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: publicEntryPath(), replace: true })
  },
})
